import { render, staticRenderFns } from "./RecognizedAsMissing.vue?vue&type=template&id=62c36b5e&"
import script from "./RecognizedAsMissing.vue?vue&type=script&lang=js&"
export * from "./RecognizedAsMissing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports